/**
 * Sign-In Field Names Constants
 * 
 * Single source of truth for field names used in sign-in records.
 * Use these constants instead of typing field names as strings to prevent typos.
 * 
 * These field names MUST match the backend schema in /app/backend/server.py
 * (SignInBase, SignInCreate, SignInUpdate models)
 */

// Regular sign-in fields (Full Time, Part Time, After School)
export const REGULAR_FIELDS = {
  DROP_OFF_TIME: 'dropOffTime',
  DROP_OFF_PERSON: 'dropOffPerson',
  PICK_UP_TIME: 'pickUpTime',
  PICK_UP_PERSON: 'pickUpPerson',
  ATTENDANCE: 'attendance',
  NOTES: 'notes',
};

// School Age specific fields (3-column: AM, PM Drop Off, PM Pickup)
export const SCHOOL_AGE_FIELDS = {
  // AM Parent Drop Off
  AM_PARENT_DROP_OFF_TIME: 'amParentDropOffTime',
  AM_DROP_OFF_PERSON: 'amDropOffPerson',
  
  // PM School Age Drop Off (bus/after school arrival)
  PM_SCHOOL_AGE_DROP_OFF_TIME: 'pmSchoolAgeDropOffTime',
  
  // PM Parent Pickup
  PM_PARENT_PICKUP_TIME: 'pmParentPickupTime',      // Note: lowercase 'u' in pickup
  PM_PARENT_PICKUP_PERSON: 'pmParentPickupPerson',  // Note: lowercase 'u' in pickup
};

// Attendance status values
export const ATTENDANCE_STATUS = {
  PRESENT: 'present',
  ABSENT: 'absent',
  LATE: 'late',
};

// Manual entry types (used in handleManualPersonEntry)
export const MANUAL_ENTRY_TYPES = {
  DROP_OFF: 'dropOff',           // Regular drop-off
  PICK_UP: 'pickUp',             // Regular pick-up
  AM_DROP_OFF: 'amDropOff',      // School Age AM drop-off
  PM_PICK_UP: 'pmPickUp',        // School Age PM parent pickup
};

// Helper to build update data for manual person entry
export const buildManualEntryData = (type, personNameWithApproval, currentTime) => {
  switch (type) {
    case MANUAL_ENTRY_TYPES.DROP_OFF:
      return {
        [REGULAR_FIELDS.DROP_OFF_PERSON]: personNameWithApproval,
        [REGULAR_FIELDS.DROP_OFF_TIME]: currentTime,
        [REGULAR_FIELDS.ATTENDANCE]: ATTENDANCE_STATUS.PRESENT,
      };
    
    case MANUAL_ENTRY_TYPES.PICK_UP:
      return {
        [REGULAR_FIELDS.PICK_UP_PERSON]: personNameWithApproval,
        [REGULAR_FIELDS.PICK_UP_TIME]: currentTime,
      };
    
    case MANUAL_ENTRY_TYPES.AM_DROP_OFF:
      return {
        [SCHOOL_AGE_FIELDS.AM_DROP_OFF_PERSON]: personNameWithApproval,
        [SCHOOL_AGE_FIELDS.AM_PARENT_DROP_OFF_TIME]: currentTime,
        [REGULAR_FIELDS.ATTENDANCE]: ATTENDANCE_STATUS.PRESENT,
      };
    
    case MANUAL_ENTRY_TYPES.PM_PICK_UP:
      return {
        [SCHOOL_AGE_FIELDS.PM_PARENT_PICKUP_PERSON]: personNameWithApproval,
        [SCHOOL_AGE_FIELDS.PM_PARENT_PICKUP_TIME]: currentTime,
      };
    
    default:
      console.error(`Unknown manual entry type: ${type}`);
      return {};
  }
};

export default {
  REGULAR_FIELDS,
  SCHOOL_AGE_FIELDS,
  ATTENDANCE_STATUS,
  MANUAL_ENTRY_TYPES,
  buildManualEntryData,
};
